import React from "react";
import Hero from "../components/hero/Hero";
// import "./Landing.css";
// import { Link } from "react-router-dom";
// import XIcon from '@mui/icons-material/X';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import InstagramIcon from '@mui/icons-material/Instagram';
// import FacebookIcon from '@mui/icons-material/Facebook';
// import WaheedIcon from "../assets/icons/waheedIcon.png"; 
// import background from "../assets/icons/background.svg"
// import middlebackgr from  "../assets/icons/middlebackgr.svg"
// import leftbackgr from "../assets/icons/leftbackgr.svg"
// import bg from "../assets/icons/bg.svg"
// import footer from "../assets/icons/footer.svg"
import Investments from "../components/investments/Investments";
import Qualifications from "../components/qualification/Qualifications";
import Achievements from "../components/achievements/Achievement";
import PositionsMemberships from "../components/positionsAndMemberships/PositionsAndMemberships";
import Resume from "../components/resume/Resume";
import Companies from "../components/companies/Companies"
import Footer from "../components/footer/Footer";
export default function landingPage() {
  return (
    <div>
      <Hero/>
      <Investments/>
      <Qualifications/>
      <Achievements/>
      <PositionsMemberships/>
      <Resume/>
      <Companies/>
    </div>
  )
}
